// extracted by mini-css-extract-plugin
module.exports = {"c2pButton":"button_c2pButton__1BHHR","btn-primary":"button_btn-primary__2YM53","btn-outline-primary":"button_btn-outline-primary__2ILhW","disabled":"button_disabled__vZgGL"};